import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=5d9cad00&scoped=true&"
import script from "./Drawer.vue?vue&type=script&lang=ts&"
export * from "./Drawer.vue?vue&type=script&lang=ts&"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=5d9cad00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9cad00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9cad00')) {
      api.createRecord('5d9cad00', component.options)
    } else {
      api.reload('5d9cad00', component.options)
    }
    module.hot.accept("./Drawer.vue?vue&type=template&id=5d9cad00&scoped=true&", function () {
      api.rerender('5d9cad00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notif/Drawer.vue"
export default component.exports